import { CategoryRoute, ProductCategoryRoute, addProductRoute, editProductRoute, EditCategoryRoute, variantManagementRoute } from '@/pages/product/route';
import type { RouteRecordRaw } from 'vue-router';

export const productRoutes: RouteRecordRaw = {
  path: '/product',
  component: () => import('@/layouts/main.vue'),
  children: [
    addProductRoute(),
    CategoryRoute(),
    EditCategoryRoute(),
    ProductCategoryRoute(),
    editProductRoute(),
    variantManagementRoute()
  ],
};
